import { Button, notification } from 'antd';
import React, { useState, useEffect } from 'react';
import { useRestaurant } from '../context/RestaurantContext';
import {
    getLocalCartItems,
    makeLocalCartItemsEmpty,
    printCurrencySymbol,
    removeLocalCartItem,
    renderPrice,
    updateAllCartItem,
} from '../helpers/_commonHelper';
import { useLanguage } from '../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import ReactGA from 'react-ga4';
import Header from '../components/Header';
import TextArea from 'antd/es/input/TextArea';
import AddonComponent from '../components/AddonComponent';
import CheckoutAddonRepeatConfirm from '../components/CheckoutAddonRepeatConfirm';
import VerifyRoomTable from '../components/VerifyRoomTable';
import Counter from '../components/Counter';
import { HOTEL_ID } from '../constants';
import { placeOrder } from '../services/apiservice';
import { CloseCircleFilled, InfoCircleOutlined } from '@ant-design/icons';

const Checkout = () => {
    const [tableNumber, setTableNumber] = useState(null);
    const [instructions, updateInstructions] = useState('');
    const [guests, updateGuests] = useState(0);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { restaurantDetails } = useRestaurant();
    const currentCurrency = printCurrencySymbol(restaurantDetails);
    const { t } = useLanguage();
    const navigate = useNavigate();

    const [outOfStockItems, setOutOfStockItems] = useState([]);
    const [api, contextHolder] = notification.useNotification();
    // cart add edit delte
    const [cartItems, setCartItems] = useState([]);
    const [cartPriceDetails, setCartPriceDetails] = useState([]);

    const [selectedMenuItem, setselectedMenuItem] = useState(null);
    const [isOpenAddonPopup, setIsOpenAddonPopup] = useState(false);
    const [selectedCartItemID, setselectedCartItemID] = useState(null);

    // addon confirmation item
    const [addonConfirmItem, setAddonConfirmItem] = useState(null);
    const [isOpenAddonConfirm, setIsOpenAddonConfirm] = useState(false);

    useEffect(() => {
        ReactGA.send({
            hitType: 'pageview',
            page: window.location.pathname + window.location.search,
        });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        setCartItemList();
    }, []);

    function setCartItemList(cartItems = null, itemId = null) {
        if (!cartItems) {
            cartItems = getLocalCartItems();
        }
        let totalTaxes = 0;
        let itemTotal = 0;
        let taxList = [];

        let fetchedcartItemList = cartItems?.map((item) => {
            let itemPrice = 0;
            let itemTax = 0;
            const tempSubItem = {
                ...item,
                id: item.id,
                itemName: item.name,
                type: item.type,
                addons: [], // contains addon-list and sub addons list,
                itemPrice,
                itemTax,
                itemCount: item.cart_item_count,
                cartItemId: item.cartItemId,
                itemActualPrice: item.price,
                cartItems: [],
            };

            // adding item price, taxes
            if (restaurantDetails?.hotel_config?.taxation_type === 'priority') {
                if (item.taxes?.length) {
                    item.taxes.sort(
                        (a, b) => a?.tax?.priority - b?.tax?.priority
                    );
                }
            }

            if (item.price > 0) {
                itemPrice += item.price;
                if (
                    restaurantDetails?.hotel_config?.taxation_type ===
                    'priority'
                ) {
                    let prevPriceWithTax = item.price;

                    item.taxes?.forEach((_tax) => {
                        let taxType = _tax.tax.type || 'percentage';
                        if (taxType === 'percentage') {
                            const taxPercentage = _tax.tax.percentage;
                            const taxes =
                                (taxPercentage * prevPriceWithTax) / 100;
                            prevPriceWithTax = prevPriceWithTax + taxes;
                            itemTax += taxes;
                            const taxobj = {
                                label: _tax.tax.name,
                                type: 'item_tax',
                                value: taxes * item.cart_item_count,
                                id: _tax.tax.id,
                            };
                            taxList.push(taxobj);
                        } else if (taxType === 'absolute') {
                            const taxPercentage = _tax.tax.percentage;
                            prevPriceWithTax = prevPriceWithTax + taxPercentage;
                            itemTax += taxPercentage;
                            const taxobj = {
                                label: _tax.tax.name,
                                type: 'item_tax',
                                value: taxPercentage * item.cart_item_count,
                                id: _tax.tax.id,
                            };
                            taxList.push(taxobj);
                        }
                    });
                } else {
                    item.taxes?.forEach((_tax) => {
                        let taxType = _tax.tax.type || 'percentage';
                        if (taxType === 'percentage') {
                            const taxPercentage = _tax.tax.percentage;
                            const taxes = (taxPercentage * item.price) / 100;
                            itemTax += taxes;
                            const taxobj = {
                                label: _tax.tax.name,
                                type: 'item_tax',
                                value: taxes * item.cart_item_count,
                                id: _tax.tax.id,
                            };
                            taxList.push(taxobj);
                        } else if (taxType === 'absolute') {
                            const taxPercentage = _tax.tax.percentage;
                            itemTax += taxPercentage;
                            const taxobj = {
                                label: _tax.tax.name,
                                type: 'item_tax',
                                value: taxPercentage * item.cart_item_count,
                                id: _tax.tax.id,
                            };
                            taxList.push(taxobj);
                        }
                    });
                }
            }

            // adding selected addons list (also adding price and taxes)
            const updateTempSubItem = (addOns, title = null) => {
                addOns?.forEach((addOn) => {
                    if (addOn.count > 0) {
                        const addonMetaData = {
                            ...addOn,
                            id: addOn.id,
                            title: title,
                            name: addOn.name,
                            count: addOn.count,
                            addonPrice: addOn.price,
                        };
                        tempSubItem.addons.push(addonMetaData);
                        if (addOn.price > 0) {
                            const totalAddonPrice = addOn.price * addOn.count;
                            itemPrice += totalAddonPrice;

                            if (
                                restaurantDetails?.hotel_config
                                    ?.taxation_type === 'priority'
                            ) {
                                if (addOn.taxes?.length) {
                                    addOn.taxes.sort(
                                        (a, b) =>
                                            a?.tax?.priority - b?.tax?.priority
                                    );
                                }
                            }

                            if (
                                restaurantDetails?.hotel_config
                                    ?.taxation_type === 'priority'
                            ) {
                                let prevAddonPrice = totalAddonPrice;
                                addOn.taxes?.forEach((_tax) => {
                                    let taxType = _tax.tax.type || 'percentage';
                                    if (taxType === 'percentage') {
                                        const taxPercentage =
                                            _tax.tax.percentage;
                                        const taxes =
                                            (taxPercentage * prevAddonPrice) /
                                            100;
                                        prevAddonPrice = prevAddonPrice + taxes;
                                        itemTax += taxes;
                                        const taxobj = {
                                            label: _tax.tax.name,
                                            type: 'item_tax',
                                            value: taxes * item.cart_item_count,
                                            id: _tax.tax.id,
                                        };
                                        taxList.push(taxobj);
                                    } else if (taxType === 'absolute') {
                                        const taxPercentage =
                                            _tax.tax.percentage;
                                        itemTax += taxPercentage;
                                        const taxobj = {
                                            label: _tax.tax.name,
                                            type: 'item_tax',
                                            value:
                                                taxPercentage *
                                                item.cart_item_count,
                                            id: _tax.tax.id,
                                        };
                                        taxList.push(taxobj);
                                    }
                                });
                            } else {
                                addOn.taxes?.forEach((_tax) => {
                                    let taxType = _tax.tax.type || 'percentage';
                                    if (taxType === 'percentage') {
                                        const taxPercentage =
                                            _tax.tax.percentage;
                                        const taxes =
                                            (taxPercentage * totalAddonPrice) /
                                            100;
                                        itemTax += taxes;
                                        const taxobj = {
                                            label: _tax.tax.name,
                                            type: 'item_tax',
                                            value: taxes * item.cart_item_count,
                                            id: _tax.tax.id,
                                        };
                                        taxList.push(taxobj);
                                    } else if (taxType === 'absolute') {
                                        const taxPercentage =
                                            _tax.tax.percentage;
                                        itemTax += taxPercentage;
                                        const taxobj = {
                                            label: _tax.tax.name,
                                            value:
                                                taxPercentage *
                                                item.cart_item_count,
                                            id: _tax.tax.id,
                                        };
                                        taxList.push(taxobj);
                                    }
                                });
                            }
                        }
                    }
                });
            };
            // adding sub-addon category and without sub-addon items in a single place
            item?.sub_addons?.forEach((subAdd) => {
                updateTempSubItem(subAdd.addons, subAdd.name);
            });
            updateTempSubItem(item.without_subaddon_addons);
            tempSubItem.itemPrice = itemPrice * item.cart_item_count; // updating item price
            itemTotal += tempSubItem.itemPrice; // updating total price
            tempSubItem.itemTax = itemTax * item.cart_item_count; // updating item tax
            totalTaxes += tempSubItem.itemTax; // updating total taxes
            return tempSubItem;
        });
        setCartItems(fetchedcartItemList);
        // this.itemTotal = itemTotal;
        // this.totalTaxes = totalTaxes;
        const finalTaxesList = taxList.reduce((acc, current) => {
            const x = acc.find((item) => item.id === current.id);
            if (!x) {
                return acc.concat([current]);
            } else {
                const indexofexistinTax = acc.findIndex((t) => t.id == x.id);
                acc[indexofexistinTax].value += current.value;
                return acc;
            }
        }, []);
        let grandTotal = itemTotal + totalTaxes;
        const arr = [
            {
                label: 'common_item_total',
                type: 'item_total',
                value: itemTotal,
            },
            ...finalTaxesList,
            // { label: "Taxes", type: "total_tax", value: totalTaxes },
            {
                label: 'common_grand_total',
                type: 'grand_total',
                value: grandTotal,
            },
        ];
        if (itemId) {
            let updatedItem = fetchedcartItemList.find(
                (item) => item.cartItemId === itemId
            );
            setAddonConfirmItem(updatedItem);
        }

        setCartPriceDetails(arr);
    }

    function updateMenuItemCount(itemId, count) {
        // setOutOfStockItems([]);
        const localCartItems = getLocalCartItems();
        const updatedCartItems = localCartItems.map((cartItem) => {
            if (itemId === cartItem.cartItemId) {
                cartItem.cart_item_count += count;
            }
            return cartItem;
        });
        updateAllCartItem(updatedCartItems);
        setCartItemList(updatedCartItems, itemId);
    }

    function removeItem(item) {
        const itemId = item.cartItemId;
        // this.isCartModified = true;
        if (item.itemCount === 1) {
            // Removing cart item if count is 1  //
            removeLocalCartItem(item.cartItemId);
            setCartItemList();
            handleAddonConfirmClose();
            // fetchRecommendedItems();
        } else {
            // Decrementing item count is count > 1 //
            updateMenuItemCount(itemId, -1);
        }
    }
    const onItemIncrease = (item) => {
        if (item.addons.length > 0) {
            setIsOpenAddonConfirm(true);
            setAddonConfirmItem(item);
            const itemId = item.cartItemId;
            setselectedCartItemID(itemId);
        } else {
            const itemId = item.cartItemId;
            updateMenuItemCount(itemId, 1);
        }
    };
    function handleAddonConfirmClose() {
        setIsOpenAddonConfirm(false);
        setAddonConfirmItem(null);
        setselectedCartItemID(null);
    }
    function addNewAddon() {
        setIsOpenAddonPopup(true);
        let newItem = JSON.parse(JSON.stringify(addonConfirmItem));
        newItem.sub_addons?.forEach((subaddon) => {
            subaddon?.addons?.forEach((addon) => {
                addon.isChecked = false;
                addon.count = 0;
            });
        });
        setselectedMenuItem(newItem);
        setselectedCartItemID(newItem.cartItemId);
        handleAddonConfirmClose();
    }
    function handleAddonClose() {
        setIsOpenAddonPopup(false);
        // dispatch(fetchMenuItems(menuID));

        setCartItemList();

        // syncItemsAfterAddonUpdate();
    }

    function duplicateItem(item) {
        // this.isCartModified = true;
        const itemId = item.cartItemId;
        updateMenuItemCount(itemId, 1);
    }

    const getCookingInstructionLabel = () => {
        let labelText = t['checkout_ird_instructions_label'];
        // eslint-disable-next-line no-unused-expressions
        restaurantDetails?.hotel_term?.forEach((element) => {
            if (element?.type === 'ird_cook_instruction') {
                if (element?.term) {
                    labelText = element?.term;
                }
            }
        });
        return <label dangerouslySetInnerHTML={{ __html: labelText }}></label>;
    };

    // Formatting cart items for checkout data
    function getApiFormattedCartItems() {
        const cartItems = getLocalCartItems();
        // const recommended_item_ids = cartItems
        //     .filter((item) => Boolean(item.is_recommended))
        //     .map((item) => item.id);
        const formattedItems = cartItems.map((cartItem) => {
            const { id, cart_item_count, sub_addons, without_subaddon_addons } =
                cartItem;

            const formattedItem = {
                menu_item_id: id,
                quantity: cart_item_count,
                addons: [],
            };

            const formatSubAddons = (addons) => {
                addons?.forEach((addon) => {
                    if (addon.count > 0) {
                        formattedItem.addons.push({
                            menu_item_addon_id: addon.id,
                            quantity: addon.count,
                        });
                    }
                });
            };

            sub_addons?.forEach((subAdd) => {
                formatSubAddons(subAdd.addons);
            });

            formatSubAddons(without_subaddon_addons);
            return formattedItem;
        });
        return formattedItems;
    }

    const submitRequestHandler = async () => {
        setError('');
        setLoading(true);

        try {
            const orderItems = getApiFormattedCartItems();
            const ID = localStorage.getItem(HOTEL_ID);

            const orderData = {
                enc_hotel_id: ID,
                table_no: tableNumber,
                no_of_guest: guests,
                description: instructions,
                items: JSON.stringify(orderItems),
            };

            const response = await placeOrder(orderData);
            if (response.status === 201) {
                ReactGA.set({ foodOrderPlaced: true });
                ReactGA.event({
                    category: 'Food',
                    action: 'Food Order Placed',
                });
                makeLocalCartItemsEmpty();
                setLoading(false);
                navigate('/restaurant-confirmation');
            }
        } catch (error) {
            const { response = {} } = error;
            if (response.status === 400) {
                let itemsIdList = response.data?.data?.unavialable_items || [];
                let errorMessage =
                    response.data?.message || 'Something went wrong!';
                api.open({
                    description: errorMessage,
                    icon: <CloseCircleFilled style={{ color: '#FF0000' }} />,
                });
                let addonsIdList =
                    response?.data?.data?.unavialable_addons || [];
                if (itemsIdList.length || addonsIdList.length) {
                    itemsIdList = itemsIdList.map((id) => Number(id));
                    addonsIdList = addonsIdList.map((id) => Number(id));
                    setOutOfStockItems([...itemsIdList, ...addonsIdList]);
                    window.scrollTo(0, 0);
                }
            }
        } finally {
            setLoading(false);
        }
    };

    const checkIfOutOfStock = (item) => {
        let isOutofStock = false;

        // check if item of addon exist
        if (outOfStockItems.includes(item.id)) {
            isOutofStock = true;
        } else if (item.addons && item.addons.length) {
            outOfStockItems?.forEach((addonID) => {
                item?.addons?.forEach((item) => {
                    if (item.id === addonID) {
                        isOutofStock = true;
                    }
                });
            });
        }
        return isOutofStock;
    };

    return (
        <>
            {contextHolder}
            <Header showBack backBtnHandler={() => navigate(-1)} />
            {!cartItems.length ? (
                <div
                    className={
                        ' flex justify-center items-center flex-col h-96'
                    }
                >
                    <p>{t['checkout_ird_food_card_empty_error']}</p>

                    <Button
                        type='primary'
                        onClick={() => navigate(-1)}
                        className='bg-theme'
                    >
                        {t['checkout_ird_empty_btn']}
                    </Button>
                </div>
            ) : (
                <section style={{ width: '100%', backgroundColor: '#f3f3f3' }}>
                    {restaurantDetails?.hotel_term?.map((item) => {
                        if (item?.type === 'ird_cart_top') {
                            return (
                                <p
                                    className='ird-checkout-warning'
                                    dangerouslySetInnerHTML={{
                                        __html: `&#x26A0; ${item.term}`,
                                    }}
                                ></p>
                            );
                        }
                    })}
                    <div className='flex flex-col gap-12 p-2 pb-16'>
                        <div className='flex flex-col gap-2'>
                            <RenderConfirmationCheckbox
                                restaurantDetails={restaurantDetails}
                            />
                            {outOfStockItems.length > 0 && (
                                <div className='out-of-service'>
                                    <div className='icon'>
                                        <i className='fa fa-info-circle'></i>
                                    </div>
                                    <div className='text'>
                                        t{'out_of_stock'}
                                    </div>
                                </div>
                            )}
                            {cartItems.map((item, position) => (
                                <div className='item-food-card' key={item.id}>
                                    <div
                                        className={
                                            checkIfOutOfStock(item)
                                                ? 'item-details-wrapper out-of-stock relative'
                                                : 'item-details-wrapper border border-gray-300 relative'
                                        }
                                    >
                                        {(item.type === 'veg' ||
                                            item.type === 'non_veg') && (
                                            <div
                                                className={
                                                    'icon-img static ' +
                                                    (item.type === 'non_veg'
                                                        ? 'non-veg'
                                                        : 'veg')
                                                }
                                            ></div>
                                        )}
                                        <div className='item-title-wrapper'>
                                            <div className='item-title-price-wrapper'>
                                                <div className='item-title'>
                                                    {item.itemName}
                                                </div>
                                                <div className='item-price'>
                                                    {item.itemPrice > 0
                                                        ? ` ${currentCurrency} ${renderPrice(
                                                              item.itemPrice,
                                                              restaurantDetails
                                                          )}`
                                                        : `  `}
                                                </div>
                                                {item.addons?.length !== 0 ? (
                                                    <ul className='selectedAddonList'>
                                                        {item?.addons?.map(
                                                            (add) => {
                                                                return (
                                                                    <li>
                                                                        <span>
                                                                            {
                                                                                add.title
                                                                            }{' '}
                                                                            {
                                                                                ' : '
                                                                            }
                                                                        </span>
                                                                        <span className='addon-name'>
                                                                            {
                                                                                add.name
                                                                            }{' '}
                                                                            {add.count >
                                                                            1
                                                                                ? ' - ' +
                                                                                  add.count
                                                                                : ''}
                                                                        </span>
                                                                        {add.addonPrice >
                                                                        0 ? (
                                                                            <span>
                                                                                {' '}
                                                                                {
                                                                                    ' x '
                                                                                }
                                                                                {
                                                                                    currentCurrency
                                                                                }{' '}
                                                                                {renderPrice(
                                                                                    add.addonPrice,
                                                                                    restaurantDetails
                                                                                )}
                                                                            </span>
                                                                        ) : null}
                                                                    </li>
                                                                );
                                                            }
                                                        )}
                                                    </ul>
                                                ) : null}
                                            </div>

                                            <Counter
                                                count={item.itemCount}
                                                increment={() =>
                                                    onItemIncrease(item)
                                                }
                                                decrement={() =>
                                                    removeItem(item)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}

                            <div
                                className={
                                    'flex justify-center items-start flex-col gap-2'
                                }
                            >
                                {getCookingInstructionLabel()}
                                <TextArea
                                    value={instructions}
                                    onChange={(e) =>
                                        updateInstructions(e.target.value)
                                    }
                                    placeholder={t['no_veggie_msg']}
                                    rows={3}
                                />
                            </div>
                            {cartPriceDetails.length > 0 ? (
                                <div className='priceDetails-wraper shadow-sm border-1'>
                                    {cartPriceDetails?.map((data, index) => {
                                        if (data.value || data.value == 0) {
                                            return (
                                                <div
                                                    className={`details-list ${data.type}`}
                                                    key={`${index}-${data.label}`}
                                                >
                                                    <span className='type_label'>
                                                        {t[`${data?.label}`]}
                                                    </span>
                                                    <span className='value_label'>
                                                        {currentCurrency}{' '}
                                                        {renderPrice(
                                                            data.value,
                                                            restaurantDetails
                                                        )}
                                                    </span>
                                                </div>
                                            );
                                        }
                                    })}
                                </div>
                            ) : null}
                        </div>

                        <div className='flex flex-col gap-4'>
                            {restaurantDetails.id === 366 && (
                                <div className='inforMsg'>
                                    <i className='fa fa-info-circle'></i>{' '}
                                    <span>
                                        Eligible discount if any will reflect on
                                        the invoice presented to you during food
                                        delivery.
                                    </span>
                                </div>
                            )}
                            {restaurantDetails.id === 472 && (
                                <div className='inforMsg'>
                                    <i className='fa fa-info-circle'></i>{' '}
                                    <span>
                                        Deck chair number can be found behind
                                        the chair.
                                    </span>
                                </div>
                            )}

                            <VerifyRoomTable
                                setVerifiedTableNumber={setTableNumber}
                            />

                            <div className='flex justify-between items-center'>
                                <label>
                                    {restaurantDetails.id === 418
                                        ? 'Number of Guests  عدد الضيوف'
                                        : t['checkout_number_of_guests']}
                                </label>
                                <Counter
                                    count={guests}
                                    increment={() => updateGuests(guests + 1)}
                                    decrement={
                                        guests === 0
                                            ? null
                                            : () => updateGuests(guests - 1)
                                    }
                                />
                            </div>

                            <div className='flex justify-center items-center'>
                                <Button
                                    disabled={!tableNumber || guests === 0}
                                    onClick={() => submitRequestHandler()}
                                    type='primary'
                                    loading={loading}
                                >
                                    {t['common_proceed_btn']}
                                </Button>
                            </div>
                            {error && <p className={''}>{error}</p>}
                        </div>
                    </div>
                </section>
            )}

            {isOpenAddonPopup && selectedMenuItem && (
                <AddonComponent
                    selectedCartItemID={selectedCartItemID}
                    menuItem={selectedMenuItem}
                    open={isOpenAddonPopup}
                    close={handleAddonClose}
                />
            )}
            {isOpenAddonConfirm && addonConfirmItem && (
                <CheckoutAddonRepeatConfirm
                    menuItem={addonConfirmItem}
                    item={addonConfirmItem}
                    open={isOpenAddonConfirm}
                    duplicateItem={duplicateItem}
                    removeItem={removeItem}
                    close={handleAddonConfirmClose}
                    addNewAddon={addNewAddon}
                    //   updateOperationType={getAddonOperationType}
                />
            )}
        </>
    );
};

export default Checkout;

const RenderConfirmationCheckbox = (props) => {
    const { restaurantDetails } = props;
    let checkboxLabelNode = restaurantDetails?.hotel_term?.find(
        (item) => item.type === 'restaurant_cart'
    );
    const checkboxLabel = checkboxLabelNode?.['term'] || 'test';
    return (
        <div className='sticky-msg'>
            <InfoCircleOutlined style={{ color: '#447eaf' }} />
            <small>{checkboxLabel}</small>
        </div>
    );
};
